import { Grid, Typography } from '@mui/material';
import { usePqrInFavorOf } from './hook';
import { PqrInFavorOfProps } from './props';
import AutocompleteField from '../../../../../components/general/fields/autocompleteField';
import { formatParams } from '../../../../../../shared/utils/params';

export const PqrInFavorOf = (props: PqrInFavorOfProps) => {
    const { formik, inFavorOfList } = usePqrInFavorOf(props);

    return (
        <Grid
            container
            spacing={{ xs: 1.5, md: 1.5 }}
            columnSpacing={{ xs: 1.5, sm: 1.5, md: 1.5 }}
            pt="20px"
        >
            <Grid item xs={12}>
                <Typography style={{ fontWeight: 'bold', color: '#000' }}>
                    A favor de
                </Typography>
            </Grid>
            <Grid item xs={12} md={4}>
                <AutocompleteField
                    data={formatParams(inFavorOfList)}
                    label="A favor de"
                    name="inFavorOf"
                    size="small"
                    required
                    onBlur={formik.handleBlur}
                    touched={formik.touched.inFavorOf}
                    errors={formik.errors.inFavorOf}
                    value={formik.values.inFavorOf}
                    onChangeValue={(value: any) =>
                        formik.setFieldValue('inFavorOf', value)
                    }
                    disabled={!props.isClousureStatus}
                />
            </Grid>
        </Grid>
    );
};
